import { rejectedColors, TimelineDuration } from "./timelineevent.styled.jsx";

export const Date = ({
  isRejected,
  timelineTheme,
  eventLengthDays,
  startDate,
  endDate,
}) => (
  <TimelineDuration
    colour={!isRejected ? timelineTheme?.textColor : rejectedColors.textColor}
  >
    {eventLengthDays > 0 && (
      <>
        {startDate.toFormat("dd.MM.")}
        {"-"}
        {endDate.toFormat("dd.MM.")}
      </>
    )}
    {eventLengthDays === 0 && <>{endDate.toFormat("dd.MM.")}</>}
  </TimelineDuration>
);
